import React, { useEffect, useRef } from 'react';

const withScrollInToView = (Component) => {
	const ScrollInToView = ({ classes, ...props }) => {
		const elemref = useRef(null);

		useEffect(() => {
			elemref.current.scrollIntoView({ inline: 'center', behavior: 'smooth' });
		}, []);

		return (
			<div className={classes} ref={elemref}>
				<Component {...props} />
			</div>
		);
	};

	return ScrollInToView;
};

export default withScrollInToView;
